/**
 * Sanitizes user input by stripping dangerous content.
 * - Removes HTML tags (including self-closing and malformed)
 * - Decodes common HTML entities before re-checking
 * - Strips javascript: and data: URI schemes
 * - Removes event handler attributes (onerror, onclick, etc.)
 * - Trims whitespace
 */
export function sanitizeInput(input) {
    let s = input;
    // Decode common HTML entities so encoded attacks are caught
    s = s
        .replace(/&#x([0-9a-fA-F]+);?/g, (_m, hex) => String.fromCharCode(parseInt(hex, 16)))
        .replace(/&#(\d+);?/g, (_m, dec) => String.fromCharCode(parseInt(dec, 10)))
        .replace(/&lt;/gi, "<")
        .replace(/&gt;/gi, ">")
        .replace(/&amp;/gi, "&")
        .replace(/&quot;/gi, '"')
        .replace(/&apos;/gi, "'");
    // Remove HTML comments
    s = s.replace(/<!--[\s\S]*?-->/g, "");
    // Remove HTML tags (including malformed, self-closing)
    s = s.replace(/<\/?[a-z][^>]*>/gi, "");
    // Remove unclosed tags at end of string (e.g., "hello<script")
    s = s.replace(/<[a-z][^>]*$/gi, "");
    // Remove dangerous URI schemes (javascript:, vbscript:, data:)
    s = s.replace(/(javascript|vbscript|data)\s*:/gi, "");
    // Remove event handler patterns (on-prefixed attributes)
    s = s.replace(/\bon[a-z]+\s*=\s*["'][^"']*["']/gi, "");
    s = s.replace(/\bon[a-z]+\s*=[^\s"'>]*/gi, "");
    return s.trim();
}
//# sourceMappingURL=sanitization.js.map